module.exports = __webpack_public_path__ + "img/TrophyThree.4914bfbe.svg";